import { Injectable } from '@angular/core';

export const DEMO_PROFILES = [
    { id: 'example-confirmed', name: '확인 명식 예시', confirmed: true, revision: '예시 v1',
        summary: '년주 甲子 · 월주 丙寅 · 일주 甲子 · 시주 제외',
        limitation: '생시 미상으로 설정한 합성 자료입니다. 대운·세운 자료는 없습니다.' },
    { id: 'example-unconfirmed', name: '확인 전 명식 예시', confirmed: false, revision: '미확인 예시',
        summary: '원국 확인 전 · 시주 판독 불가',
        limitation: '판독 불가와 실제 생시 미상은 다릅니다. 원본 대조와 사용자 확인이 필요합니다.' }
] as const;

@Injectable({ providedIn: 'root' })
export class ExplorationSession {
    private key = 'saju.exploration.profile.v1';
    public selectedId = '';
    public storageUnavailable = false;

    constructor() {
        try {
            const value = sessionStorage.getItem(this.key);
            this.selectedId = DEMO_PROFILES.find(profile => profile.id === value)?.id || '';
        } catch {
            this.storageUnavailable = true;
        }
    }

    get profile() { return DEMO_PROFILES.find(profile => profile.id === this.selectedId); }

    select(id: string) {
        this.selectedId = DEMO_PROFILES.find(profile => profile.id === id)?.id || '';
        try {
            if (this.selectedId) sessionStorage.setItem(this.key, this.selectedId);
            else sessionStorage.removeItem(this.key);
        } catch {
            this.storageUnavailable = true;
        }
    }
}
